import AbstractNotifier from '@/utils/Services/Agent/Notifiers/AbstractNotifier';
import TravelnetImporterNotifyPolicy from "@/policies/Proposal/Product/ProductPolicy/TravelnetImporterNotifyPolicy";

export default class TravelnetImporterNotifier extends AbstractNotifier {
    get title() {
        return 'Travelnet importer notify';
    }

    get notificationTitle() {
        return 'Notificatie via Travelnet API';
    }

    proposalProductPolicy() {
        return TravelnetImporterNotifyPolicy;
    }

    canImportProduct() {
        return true;
    }
}
